define('storage',[
    "jquery",
    "logging",
    "utilities"
], function($, logging, utilities) {
    "use strict";

    var _ModuleName = "Storage";
    var _config = {
        storageType: 1,
        allowHtml5Storage: true,
        nameTemplate: "path-storage-",
        types: {
            html5: 1,
            cookie: 2
        },
        cookie: {
            expiration: {
                local: 8760,    // 1 year
                session: 2      // 2 hours
            }
        }
    }

    function init() {
        if (_config.allowHtml5Storage && typeof(Storage) !== "undefined") {
            ;
            _config.storageType = _config.types.html5;
        } else {
            ;
            _config.storageType = _config.types.cookie;
        }
    }

    function getLocalStorage(name) {
        var result;
        if(_config.storageType == _config.types.html5) {
            // Use HTML Storage Functionality
            result = localStorage.getItem(_config.nameTemplate + name);
        } else {
            // Use Cookies
            result = utilities.getCookie(_config.nameTemplate + name);
        }
        return result ? JSON.parse(result) : result;
    }

    function getSessionStorage(name) {
        var result;
        if(_config.storageType == _config.types.html5) {
            // Use HTML Storage Functionality
            result = sessionStorage.getItem(_config.nameTemplate + name);
        } else {
            // Use Cookies
            result = utilities.getCookie(_config.nameTemplate + name);
        }
        return result ? JSON.parse(result) : result;
    }

    function setLocalStorage(name, value) {
        if(_config.storageType == _config.types.html5) {
            try {
            // Use HTML Storage Functionality
            localStorage.setItem(_config.nameTemplate + name, JSON.stringify(value));
            } catch(e) {
                Storage.prototype._setItem = Storage.prototype.setItem;
                Storage.prototype.setItem = function() {};
                logging.error('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.', _ModuleName);

                return false;
            }
        } else {
            // Use Cookies
            utilities.setCookieByHours(_config.nameTemplate + name, JSON.stringify(value), _config.cookie.expiration.local);
        }

        return true;
    }

    function setSessionStorage(name, value) {
        if(_config.storageType == _config.types.html5) {
            try {
            // Use HTML Storage Functionality
            sessionStorage.setItem(_config.nameTemplate + name, JSON.stringify(value));
            } catch(e) {
                Storage.prototype._setItem = Storage.prototype.setItem;
                Storage.prototype.setItem = function() {};
                logging.error('Your web browser does not support storing settings locally. In Safari, the most common cause of this is using "Private Browsing Mode". Some settings may not save or some features may not work properly for you.', _ModuleName);

                 return false;
            }
        } else {
            // Use Cookies
            utilities.setCookieByHours(_config.nameTemplate + name, JSON.stringify(value), _config.cookie.expiration.session);
        }

        return true;
    }

    return {
        init: init,
        getLocalStorage: getLocalStorage,
        getSessionStorage: getSessionStorage,
        setLocalStorage: setLocalStorage,
        setSessionStorage: setSessionStorage
    }
});
